import React, { Component, Fragment } from 'react';
import ActivationKeyModal from './ActivationKeyModal';


export default class ActivationKeyLink extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        const { show } = this.state;
        this.setState({
            show: !show
        });
    }

    render () {
        const { activationKey } = this.props;
        const { show } = this.state;
        return (
            <Fragment>
                <ActivationKeyModal activationKey={activationKey} handleClose={this.handleClick} show={show} />
                <a onClick={this.handleClick}
                    href="javascript:void(0)"
                    className="dropdown-item"
                >Chave de Ativação</a>
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/ActivationKeyLink.js